import React, { useEffect, useState } from 'react';
import {
  Typography,
  TextField,
  Container,
  Tooltip,
  Grid,
  IconButton,
  CircularProgress,
} from '@mui/material';
import { makeStyles } from '@mui/styles';
import Search from '@mui/icons-material/Search';
import style from '../../Tools/Style';
import { obtenerFacturasCliente } from '../../../actions/CobranzasAction.js';
import ModalClientes from '../../GestionDeClientes/ModalClientes';
import { obtenerClientes } from '../../../actions/ClientesAction';
import TBajaFacturas from './TBajaFacturas';
const useStyles = makeStyles((theme) => ({
  '@keyframes blinker': {
    from: { opacity: 1 },
    to: { opacity: 0 },
  },
  icon: {
    animationName: '$blinker',
    animationDuration: '1s',
    animationTimingFunction: 'linear',
    animationIterationCount: 'infinite',
  },
}));
export default function DarDeBajaFacturas(props) {
  const classes = useStyles();
  const [modalBuscar, setModalBuscar] = useState(false);
  const [datosCargados, setDatosCargados] = useState(true);
  const [cliente, setCliente] = useState({
    nombre: '',
    apellido: '',
    clientE_Id: '',
  });
  const [Datacl, setDatacl] = useState([]);
  const [datosCargadosModal, setDatosCargadosModal] = useState(true);
  const [rows, setRows] = useState([]);
  const seleccionarCliente = (cliente) => {
    setCliente(cliente);
    setModalBuscar(false);
  };
  const abrirModal = () => {
    setModalBuscar(true);
  };

  const cerrarModal = () => {
    setModalBuscar(false);
  };
  useEffect(() => {
    setDatosCargadosModal(false);
    obtenerClientes().then((response) => {
      const Data = response.data;
      setDatacl(Data);
      setDatosCargadosModal(true);
    });
    if (cliente.clientE_Id !== '') {
      setDatosCargados(false);
      obtenerFacturasCliente(cliente.clientE_Id).then((response) => {
        if (response.status === 200) {
          response.data.map((row) => (row['importe'] = 0));
          setRows(response.data);
          setDatosCargados(true);
        } else {
          console.log('ERROR EN TRAER FACTURAS DE CLIENTE');
        }
      });
    }
  }, [cliente]);
  return (
    <Container maxWidth="lg" justify="center">
      <Typography align="center" variant="h5">
        DAR DE BAJA FACTURAS
      </Typography>
      <Grid container direction="row">
        <Grid item lg={12} md={12} xs={12} sm={12}>
          <br />
          <Tooltip title="Buscar Cliente">
            <IconButton className={classes.icon} onClick={abrirModal}>
              <Search style={{ fontSize: 40, marginTop: 5 }} />
            </IconButton>
          </Tooltip>
          <TextField
            value={cliente.nombre + ' ' + cliente.apellido}
            style={style.Selectrol}
            variant="outlined"
            label=" Buscar"
            disabled={true}
          />
        </Grid>
      </Grid>
      <br />
      {datosCargados ? (
        <TBajaFacturas
          rows={rows}
          setRows={setRows}
          setCliente={setCliente}
          cliente={cliente}
        />
      ) : (
        <CircularProgress />
      )}

      <Grid container direction="row" justify="center" alignItems="center">
        <ModalClientes
          data={Datacl}
          open={modalBuscar}
          handleClose={cerrarModal}
          seleccionarCliente={seleccionarCliente}
          datosCargados={datosCargadosModal}
        />
      </Grid>
    </Container>
  );
}
